import React from 'react';
import PropTypes from 'prop-types';
import DialogTemplate from '../../dialogs_common/DialogTemplate';
import Project from '../../pages/project/ProjectPast'
import CloseDialogButton from '../../dialogs_common/CloseDialogButton';
import Banner from './Banner';

ProjectDetailsDialog.propTypes = {
  project: PropTypes.object.isRequired
};

export default function ProjectDetailsDialog(props) {
  const { project } = props;

  return (
    <DialogTemplate className="max-w-screen-lg">
      <CloseDialogButton onCancel={props.onCancel} />
      <div className="px-6 pt-16 pb-6">
        <div className="space-y-8">
          {/*<Banner project={project} />*/}
          <Project project={project} />
        </div>
      </div>
    </DialogTemplate>
  );
};
